// Module
var code = "<label data-local-qa-id=\"required-name\" class=\"control-label\" ng-transclude></label><cr-form-error error-messages=\"$ctrl.errorMessages\" for=\"{{ $ctrl.for }}\" type=\"{{ $ctrl.type }}\" custom-class=\"{{ $ctrl.customClass }}\"></cr-form-error> ";
// Exports
export default code;